/**
 * Creative Library Validators
 */

import {
	valueExists
	, isEmail
	, overLimit
	, overMax
	// , validSelection
} from './validators';

export const CREATIVE_LIBRARY_NAME_LIMIT = 250;
export const ADVERTISER_NAME_LIMIT = 250;
export const BRAND_NAME_LIMIT = 250;
export const PRIMARY_CONTACT_LIMIT = 100;
export const MEDIA_BUYER_LIMIT = 250;
export const MEDIA_BUYER_EMAIL_LIMIT = 50;
export const CONTENT_LIMIT_MIN = 0;
export const CONTENT_LIMIT_MAX = 32767;
export const DEFAULT_LIMIT = 300;

// we have to declare the regex in each function because for some reason if we make it a constant it only works every other time?
export const NAME_CHARS = "a-z, A-Z, 0-9, _, ', @, &, %, ~, space, comma, period";

const VALID_CHARS = "Alpha-numeric _ ' . & and space";
const VALID_CHARS_UMLAUT = 	"Alpha-numeric, À-Ö, Ø-ö, ø-ÿ, _+.:()/«»!&~@#$%^*=|-\\";

// Name *
function name(value, formValues, formProps, field){
	if(!valueExists(value)){
		return "Creative Library Name is Required.";
	}
	if(overLimit(value, CREATIVE_LIBRARY_NAME_LIMIT)){
		return `Creative Library Name must be fewer than ${CREATIVE_LIBRARY_NAME_LIMIT} characters.`;
	}
	if(!/^[\w\s\'\.\,\@\&\%~]+$/gi.test(value)){
		return `Creative Library Name can consist only of the following characters: ${NAME_CHARS}.`;
	}
}

// Advertiser *
function advertiserName(value, formValues, formProps, field){
	if(!valueExists(value)){
		return "Advertiser is Required.";
	}
	if(overLimit(value, ADVERTISER_NAME_LIMIT)){
		return `Advertiser must be fewer than ${ADVERTISER_NAME_LIMIT} characters.`;
	}
	if(!/^[ a-zA-Z0-9_+.:()/«»!&~À-ÖØ-öø-ÿ@#$%^*=|\\\\-]+$/gi.test(value)){
		return `Advertiser can consist only of the following characters: ${VALID_CHARS_UMLAUT}.`;
	}
}

// Brand / Product
function brand(value, formValues, formProps, field){
	if(valueExists(value)){
		if(overLimit(value, BRAND_NAME_LIMIT)){
			return `Brand / Product must be fewer than ${BRAND_NAME_LIMIT} characters.`;
		}
		if(!/^[\w\s\'\.\&]+$/gi.test(value)){
			return `Brand / Product can consist only of the following characters: ${VALID_CHARS}.`;
		}
	}
}

// Primary Contact *
function email(value, formValues, formProps, field){
	if(!valueExists(value)){
		return "Primary Contact is Required.";
	}
	if(overLimit(value, PRIMARY_CONTACT_LIMIT)){
		return `Primary Contact must be fewer than ${PRIMARY_CONTACT_LIMIT} characters.`;
	}
	if(!isEmail(value)){
		return "Primary Contact must be a valid email address.";
	}
}

// Media Buyer
function mediaBuyerName(value, formValues, formProps, field){
	const { disableMediaBuyerName } = formProps || {};

	if(!disableMediaBuyerName && valueExists(value)){
		if(overLimit(value, MEDIA_BUYER_LIMIT)){
			return `Media Buyer must be fewer than ${MEDIA_BUYER_LIMIT} characters.`;
		}
		if(!/^[ a-zA-Z0-9_+.:()/«»!&~À-ÖØ-öø-ÿ@#$%^*=|\\\\-]+$/gi.test(value)){
			return `Media Buyer can consist only of the following characters: ${VALID_CHARS_UMLAUT}.`;
		}
	}
}

// Media Buyer Email
export function mediaBuyerEmail(value, formValues, formProps, field){
	// TODO: validation is more complicated on edit
	if(valueExists(value)){
		if(overLimit(value, MEDIA_BUYER_EMAIL_LIMIT)){
			return `Media Buyer Email must be fewer than ${MEDIA_BUYER_EMAIL_LIMIT} characters.`;
		}
		if(!isEmail(value)){
			return "Media Buyer Email must be a valid email address.";
		}
	}
}

function otherRecipientsEmail(value) {
	if(value && !isEmail(value)) {
		return "Recipients must have a valid email address";
	}
}

// Dynamic Ad File Size Limit (kb) *
function contentLimitInKilobytes(value, formValues, formProps, field){
	if(!valueExists(value) && value !== 0){
		return "Dynamic Ad File Size Limit (kb) is Required.";
	}
	if(isNaN(value)){
		return "Dynamic Ad File Size Limit (kb) must be a Number.";
	}
	if(value < CONTENT_LIMIT_MIN || overMax(value, CONTENT_LIMIT_MAX)){
		return `Dynamic Ad File Size Limit (kb) must be between ${CONTENT_LIMIT_MIN} and ${CONTENT_LIMIT_MAX}.`;
	}
}

// QA Territory *
function qaLocation(value, formValues, formProps, field){
	if(!valueExists(value)){
		return `QA Territory is Required.`;
	}
}

export function validateForm(formValues, formProps){
	return {
		name: name(formValues.name, formValues, formProps, "name"),
		advertiserName: advertiserName(formValues.advertiserName, formValues, formProps, "advertiserName"),
		contentLimitInKilobytes: contentLimitInKilobytes(formValues.contentLimitInKilobytes, formValues, formProps, "contentLimitInKilobytes"),
		qaLocation: qaLocation(formValues.qaLocation, formValues, formProps, "qaLocation"),
		brand: brand(formValues.brand, formValues, formProps, "brand"),
		email: email(formValues.email, formValues, formProps, "email"),
		mediaBuyerName: mediaBuyerName(formValues.mediaBuyerName, formValues, formProps, "mediaBuyerName"),
		mediaBuyerEmail: mediaBuyerEmail(formValues.mediaBuyerEmail, formValues, formProps, "mediaBuyerEmail"),
	};
}


const Validators = {
	name,
	advertiserName,
	brand,
	email,
	mediaBuyerName,
	mediaBuyerEmail,
	contentLimitInKilobytes,
	qaLocation,
	otherRecipientsEmail,
};

export default Validators;
